import { headerShipToAddressStyles as styles } from "@insite/content-library/Widgets/Common/HeaderShipToAddress";
import { DrawerPresentationProps } from "@insite/mobius/Drawer";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css, ThemeProps } from "styled-components";

const maxWidths = ({ theme }: ThemeProps<any>) => {
    const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
    return breakpointMediaQueries(theme, [
        css`
            max-width: ${maxWidths[1]}px;
        `,
        css`
            max-width: ${maxWidths[1]}px;
        `,
        css`
            max-width: ${maxWidths[2]}px;
        `,
        css`
            max-width: ${maxWidths[3]}px;
        `,
        css`
            max-width: ${maxWidths[4]}px;
        `,
    ]);
};

const baseDrawerStyle = (drawer?: DrawerPresentationProps): DrawerPresentationProps => ({
    ...drawer,
    cssOverrides: {
        ...drawer?.cssOverrides,
        drawerTitle: css`
            ${drawer?.cssOverrides?.drawerTitle}
            margin: auto;
            padding: 5px 15px;
            width: 100%;

            ${maxWidths}
        `,
        drawerContent: css`
            ${drawer?.cssOverrides?.drawerContent}
            margin: auto;
            width: 100%;

            ${maxWidths}
        `,
        headlineTypography: css`
            margin: 7px 0;
        `,
    },
});

styles.titleTypography = {
    ...styles.titleTypography,
    color: colorStrings.commonGlobalGray01,
    size: "18px",
    lineHeight: "20px",
    weight: 400,
    transform: "none",
    css: css`
        ${styles.titleTypography?.css}
        &:hover {
            text-decoration: underline;
            color: ${getColor(colorStrings.primaryMain)};
        }
    `,
};

styles.drawerInShell = baseDrawerStyle(styles.drawerInShell);

styles.drawerInPunchOut = baseDrawerStyle(styles.drawerInPunchOut);

styles.drawer = baseDrawerStyle(styles.drawer);

styles.titleIcon = {
    ...styles.titleIcon,
    size: 17,
    color: colorStrings.primaryMain,
};
